import React, { useState } from 'react';

export const ShowMapContext:any = React.createContext({});
export const ShowMapContextProvider = (props: { children: React.ReactNode }) => {
	const [ShowMap, setShowMap] = useState(true);
	return (
		<ShowMapContext.Provider
			value={{
				data: ShowMap,
				set: (e) => {
					setShowMap(e);
				},
				setShowMap:setShowMap
			}}
		>
			{props.children}
		</ShowMapContext.Provider>
	);

};